import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication';

export const customerSelectionRedirectGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const shouldShowOnboarding = inject(
    AuthenticationService
  ).shouldShowOnboarding();

  return shouldShowOnboarding
    ? router.createUrlTree(['/customer-select-transition'])
    : true;
};
